import { render, staticRenderFns } from "./HJ0083.vue?vue&type=template&id=b2704cb8&scoped=true&"
import script from "./HJ0083.vue?vue&type=script&lang=js&"
export * from "./HJ0083.vue?vue&type=script&lang=js&"
import style0 from "./HJ0083.vue?vue&type=style&index=0&id=b2704cb8&prod&lang=less&scoped=true&"
import style1 from "./HJ0083.vue?vue&type=style&index=1&id=b2704cb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2704cb8",
  null
  
)

export default component.exports